//
//
//
//
//
//
//
//
//

export default {
  name: 'flow-state',
  props: {
    state: [String, Number],
    title: String,
    isDone: Boolean
  },
  computed: {
    titlePosition () {
      return this.$parent.orientation === 'vertical' ? 'right' : 'bottom'
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/flow/flow-state.vue